
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Hamburger',
  props: {
    isActived: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const toggleClick = () => {
      emit('toggleClick');
    };
    return {
      toggleClick,
    };
  },
});
